// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_bf-4";
export var collapsed = "_bf-1";
export var headerBar = "_bf-0";
export var leftHeaderContent = "_bf-3";
export var subjectContainer = "_bf-2";